<script lang="ts">
	import LeftNavigation from "./LeftNavigation.svelte";
	import { appState } from "$lib/state/app-state.svelte";
	import type { DocumentGroup } from "$lib/navigation/document-group";

	interface Props {
		groups: DocumentGroup[];
		slug: string;
	}

	const { groups, slug }: Props = $props();
</script>

{#if appState.menuVisible}
	<div
		class="fixed inset-0 top-14 z-40 bg-zinc-400/20 backdrop-blur-xs data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in dark:bg-black/40"
		aria-hidden="true"
		onclick={() => (appState.menuVisible = false)}>
	</div>
	<div
		class="fixed top-14 bottom-0 left-0 z-40 w-full overflow-y-auto bg-white px-4 pt-6 pb-4 shadow-lg ring-1 shadow-zinc-900/10 ring-zinc-900/7.5 duration-500 ease-in-out data-closed:-translate-x-full min-[416px]:max-w-sm sm:px-6 sm:pb-10 dark:bg-zinc-900 dark:ring-zinc-800">
		<LeftNavigation groups={groups} slug={slug} class="block" />
	</div>
{/if}
